import { ReactNode } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export const RecommendTabLayout = ({ children }: { children: ReactNode }) => <Layout>{children}</Layout>;

const Layout = styled.article`
  padding-top: 8px;
  margin-bottom: 80px;
  min-height: 235px;
  overflow: hidden;

  div + section {
    border-top: 8px solid ${vars.v3Color.gray100};
  }

  section + section {
    border-top: 8px solid ${vars.v3Color.gray100};
  }

  .recommend-related-stylist-list {
    border-top: none;
    &.stylist-single-page {
      margin: 0 0 24px 0;
    }

    &.stylist-multi-page {
      margin: 0 0 20px 0;
    }
  }
`;
